import { Component, OnInit, Input } from '@angular/core';
@Component({
  selector: 'mono-common-header-help',
  templateUrl: './header-help.component.html'
})
export class HeaderHelpComponent implements OnInit {

  @Input() public helpLink: string;
  @Input() public currentRoute: string;
  @Input() public helpText?: string;

  constructor() { }

  ngOnInit(): void {
  }
}